module.exports = __webpack_public_path__ + "static/media/Theta-test.154f012e.wav";